import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../components/Logo';
import { Reveal } from '../../components/Motion';
import { APP } from '../../constants';
import { colors } from '../../theme';

const ROLES = [
  {
    role: 'user',
    emoji: '🙋',
    title: 'I need a service',
    text: 'Book services, order from local shops, find jobs, hire a cab and more.',
    color: colors.primary,
    tint: colors.primaryLight,
  },
  {
    role: 'partner',
    emoji: '🧰',
    title: 'I provide a service',
    text: 'Register your shop, skill or vehicle and start receiving customers near you.',
    color: colors.accent,
    tint: colors.accentLight,
  },
];

/** First real choice in the portal: customer side or partner side. */
const RoleSelectPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column' }}>
      <div style={{ textAlign: 'center', padding: '48px 20px 32px' }}>
        <div style={{ display: 'inline-block' }}><Logo size={72} /></div>
        <div style={{ fontSize: 30, fontWeight: 800, letterSpacing: 1, color: colors.primary, marginTop: 12 }}>
          {APP.name}
        </div>
        <div className="t-small" style={{ marginTop: 2 }}>{APP.tagline}</div>
      </div>

      <div style={{ maxWidth: 560, width: '100%', margin: '0 auto', padding: '0 22px' }}>
        <h2 className="h2">How do you want to start?</h2>
        <p className="t-small" style={{ marginTop: 4, marginBottom: 20 }}>
          You can switch or add a business later from your account.
        </p>

        {ROLES.map((r, i) => (
          <Reveal key={r.role} delay={120 + i * 110}>
            <button
              type="button"
              onClick={() => navigate(`/login?role=${r.role}`)}
              className="press"
              style={{
                display: 'flex', alignItems: 'center', gap: 16, width: '100%',
                background: '#fff', borderRadius: 22, padding: 16,
                border: `1.4px solid ${r.color}`, marginBottom: 16, textAlign: 'left',
                boxShadow: 'var(--sh-sm)',
              }}
            >
              <span
                style={{
                  width: 62, height: 62, borderRadius: 16, background: r.tint,
                  display: 'grid', placeItems: 'center', fontSize: 32, flex: '0 0 auto',
                }}
              >
                {r.emoji}
              </span>
              <span className="grow">
                <span className="h3" style={{ display: 'block' }}>{r.title}</span>
                <span className="t-small" style={{ display: 'block', marginTop: 4, lineHeight: 1.5 }}>{r.text}</span>
              </span>
              <span style={{ fontSize: 22, color: r.color }}>›</span>
            </button>
          </Reveal>
        ))}

        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Link to="/" className="link-btn">← Back to kaamwala.com</Link>
        </div>
      </div>

      <div className="t-tiny" style={{ textAlign: 'center', letterSpacing: 1.4, padding: '32px 0' }}>
        {APP.motto}
      </div>
    </div>
  );
};

export default RoleSelectPage;
